import { Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output } from "@angular/core";
import { ControlValueAccessor, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { ControlComponent } from "../../control.component";
import { CheckBoxListControl } from "../check-box-list-control.model";
import { CheckBoxListControlController } from "./check-box-list-control.controller";
import { MultiSelectOption } from "../../../../core/interfaces/multi-select-option";
import { CheckBoxListControlValue } from "./check-box-list-control-value.model";

@Component({
    selector: "checkboxlist-field",
    template: `
        <ion-select multiple="true" (ionChange)="onChange($event)">
            <ion-option *ngFor="let item of listItems" [value]="item.value" [selected]="item.selected">{{item.label}}
            </ion-option>
        </ion-select>
    `,
    providers: [
        CheckBoxListControlController,
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CheckBoxListControlComponent), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => CheckBoxListControlComponent), multi: true }
    ]
})
export class CheckBoxListControlComponent extends ControlComponent implements ControlValueAccessor, OnInit {
    @Input("value") _value: Array<string>;
    @Input() definition: CheckBoxListControl;
    @Input() formControl: FormControl;
    @Input() formGroup: FormGroup;
    @Input() assetId: string;
    @Output() changes: EventEmitter<any> = new EventEmitter();

    listItems: Array<MultiSelectOption>;

    constructor(protected elemRef: ElementRef, protected controller: CheckBoxListControlController) {
        super(elemRef);
    }

    writeValue(value?: any): void {
        super.writeValue(value);
        value = new CheckBoxListControlValue(value);
        this.listItems = this.controller.getItems(value, this.definition.config.lookupType, this.definition.config.checked);
    }

    onChange($event): void {
        this.updateValue(this.controller.getValue($event));
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/check-box-list/form/check-box-list-control.component.ts